import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import i18n from './i18n';
const container = document.getElementById('compound-interest-calculator-root');
if (container) {
    // Get language from data-lang attribute, default to 'en'
    const lang = container.getAttribute('data-lang') || 'en';
    // Set the language in i18n
    i18n.changeLanguage(lang);
    const root = createRoot(container);
    root.render(React.createElement(App, null));
}
